/** @format */

import React from "react";
import Card from "./landing/Card";
import CardSection from "./landing/CardSection";
import Subtitle from "./landing/Subtitle";
import Title from "./landing/Title";
import Photo1 from "../assets/Matthew-Iyiola.png";
import Photo2 from "../assets/Edema-Ero.jpg";
import Photo3 from "../assets/Tonia.jpg";

const CardItem = [
  {
    title: "Matthew Iyiola",
    summary:
      "As someone who works from home, I rarely find the time to go out. And thanks to Fitstats, I don't have to leave my house to get in shape.",
    icon: Photo1,
  },

  {
    title: "Edema Ero",
    summary:
      "I love that I can choose between in-house workouts and outdoor workouts. It makes things so much easier for me.",
    icon: Photo2,
  },

  {
    title: "Antonia Akpovire",
    summary:
      "What I love the most about this app is that it allows me to keep working out even if I can't go to the gym.",
    icon: Photo3,
  },
];

const Reviews = () => {
  return (
    <div className="reviews-bg pt-[64px] pb-[121px]" id="reviews">
      <div className="flex flex-col justify-center items-center mb-[120px]">
        <Title title="OUR REVIEWS" titleClass="title-text" />
        <Subtitle summary="Here's what users have to say about how FitStats helps them achieve their goals." />
      </div>
      <CardSection>
        {CardItem &&
          CardItem.map((card, key) => (
            <Card
              flex={true}
              key={key}
              title={card.title}
              summary={card.summary}
              icon={card.icon}
              color="text-[#511272]"
              stars={true}
              alignItems="items-start"
              fontWeight="font-bold"
            />
          ))}
      </CardSection>
    </div>
  );
};

export default Reviews;
